import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "../types/types";

export interface NotificationState {
  notifications: Notification[];
}

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      // state.notifications = [...state.notifications, action.payload];
      // ---------- live update status 
      //   return {
      //    ...state,
      //    notifications: [...state.notifications, action.payload],
      //  };
      // },
      // --------------- update state when new message come with different status
      const existingIndex = state.notifications.findIndex(
        (n) => n.orderId === action.payload.orderId
      );

      if (existingIndex !== -1) {
        // If orderId exists update only orderStatus
        state.notifications[existingIndex].orderStatus = action.payload.orderStatus;
        state.notifications[existingIndex].body = action.payload.body;
      } else {
        // If new order add to notification list
        state.notifications.push(action.payload);
      }
    },
    clearNotifications: (state) => {
      return {
        ...state,
        notifications: [],
      };
    },
    clearNotificationById: (state, action: PayloadAction<number>) => {
      
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        ),
      };
    },
  },
});

export const { addNotification, clearNotifications, clearNotificationById } =
  notificationSlice.actions;
export default notificationSlice.reducer;
